export const featureTitle = ({feature, collection}) => {
  // first check if the feature has a title property defined in the collection
  const titleProperty = collection?.title_property;
  if (titleProperty && feature?.properties[titleProperty]?.toString()) {
    return feature.properties[titleProperty].toString();
  }
  return feature?.properties?.title?.toString();
};
